import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { AuthProvider } from './context/AuthContext';
import ProtectedRoute from './components/ProtectedRoute';
import Login          from './pages/Login';
import Dashboard      from './pages/Dashboard';
import Retiradas      from './pages/Retiradas';
import Agenda         from './pages/Agenda';
import Bloqueios      from './pages/Bloqueios';
import Funcionarios   from './pages/Funcionarios';
import AlterarSenha   from "./pages/AlterarSenha";

export default function App() {
    return (
        <AuthProvider>
            <BrowserRouter>
                <Routes>
                    <Route path="/login" element={<Login />} />

                    <Route path="/" element={
                        <ProtectedRoute><Dashboard /></ProtectedRoute>
                    }/>
                    <Route path="/retiradas" element={
                        <ProtectedRoute><Retiradas /></ProtectedRoute>
                    }/>
                    <Route path="/agenda" element={
                        <ProtectedRoute><Agenda /></ProtectedRoute>
                    }/>
                    <Route path="/bloqueios" element={
                        <ProtectedRoute><Bloqueios /></ProtectedRoute>
                    }/>
                    <Route path="/funcionarios" element={
                        <ProtectedRoute apenasAdmin><Funcionarios /></ProtectedRoute>
                    }/>
                    <Route path="/alterar-senha" element={
                        <ProtectedRoute><AlterarSenha /></ProtectedRoute>
                    } />

                    <Route path="*" element={<Navigate to="/" replace />} />
                </Routes>
            </BrowserRouter>
        </AuthProvider>
    );
}
